export const RECEIPT_PRINT_OPTIONS = {
  NEVER: 'never',
  ALWAYS: 'always',
  ASK: 'ask',
} as const;

export const RECEIPT_RECIPIENTS = {
  MERCHANT: 'merchant',
  CARD_HOLDER: 'cardHolder',
} as const;
